import { Component } from '@angular/core';
import { AuthService } from "@authentication/auth.service";
import { TipoUsuario } from '@shared/enums/tipoUsuario';

@Component({
  selector: 'app-iata-index',
  templateUrl: './iata-index.component.html',
  styleUrl: './iata-index.component.scss'
})
export class IataIndexComponent {

  TipoUsuario = TipoUsuario;

  constructor(private authService : AuthService) { }

  hasRole(...roles: TipoUsuario[]) {
    return this.authService.hasRole(...roles);
  }
}
